<template>
    <div class="container">
        <el-button type="primary" icon="el-icon-search"  @click="toDetails" style="margin-bottom: 20px">签约统计</el-button>

        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="类型">
                <template slot-scope="scope">
                    {{ scope.row.name }}
                </template>
            </el-table-column>

            <el-table-column label="签约规则">
                <template slot-scope="scope">
                    {{ scope.row.sign_type }}
                </template>
            </el-table-column>
            <el-table-column label="开关">
                <template slot-scope="scope">
                   
                    <el-switch
                       
                        
                        v-model="scope.row.is_show"
                       
                        active-value="1"
                        inactive-value="0"
                        @change="setShowDriverSignRule(scope.row)"
                    >
                    </el-switch>

                
                </template>
            </el-table-column>

            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <!-- 编辑按钮 -->
                    <el-button type="primary" size="mini" margin-right:5px @click="editDriverSignRule(scope.row.job_type)" trigger="click">
                        编辑
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

       
        <!--  签约统计组件  -->
    <driverSignDetailsList :isShow="details_isShow"></driverSignDetailsList>

        <!-- 编辑组件 -->
        <editDriverSignNatural :isShow="nature_isShow" :data="job_type" @onSubmit="getDriverSignRuleConf"></editDriverSignNatural>
       
    </div>
</template>

<script>
var _this;

import editDriverSignNatural from './editDriverSignNatural.vue';
import driverSignDetailsList from './driverSignDetailsList.vue'

export default {
    components: {
        driverSignDetailsList,
        editDriverSignNatural
    },
    data() {
        return {
           
            
            
            //翻页数据
            search_data: {
                page: 1,
                limit: 10
            },

            job_type: '',

            nature_isShow: false,

            // 存放表格数据
            tableData: [],
           

            result_data: [],
          
            details_isShow:false,
        };
    },
    created() {
        _this = this;
       
        _this.getDriverSignRuleConf();
        
    },

    methods: {
        setShowDriverSignRule(val) {
         


            _this
                .$post('/driversign/setShowDriverSignRule', {is_show:val.is_show,job_type:val.job_type})
                .then((res) => {
                    
                    _this.$message.success(res.msg);
                    _this.getDriverSignRuleConf();
                   
                })
                .catch((err) => {});
        },
        //查看详情
      toDetails(){
        console.log('查看按钮');

        _this.details_isShow = ! _this.details_isShow

      },
        
        // 编辑按钮方法
        editDriverSignRule(job_type) {
            _this.nature_isShow = !_this.nature_isShow;

            _this.job_type = job_type;
        },

        searchgetDriverSignRuleConf() {
            _this.search_data.page = 1;
            _this.getDriverSignRuleConf();
        },

        getDriverSignRuleConf() {
            _this
                .$post('/driversign/getDriverSignRuleConf')
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.getDriverSignRuleConf();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
